import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UIStateEnum} from "../../enum/UIStateEnum";
import {IGameInstance} from "../../interfaces/IGameInstance";
import {ColDef, GridApi, GridReadyEvent} from "ag-grid-community";
import {GameInstanceStatusPipe} from "../../pipes/game-instance-status.pipe";
import {DatePipe} from "@angular/common";
import {GameInstanceService} from "../../services/game-instance.service";
import {FormatCurrencyPipe} from "../../pipes/format-currency.pipe";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {DateService} from "../../services/date.service";
import {MatFormField, MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatDatepicker, MatDatepickerModule, MatDatepickerToggle} from "@angular/material/datepicker";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {AgGridAngular} from "ag-grid-angular";
import {MatIcon} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {ActiveUserService} from "../../services/active-user.service";

@Component({
  selector: 'app-choose-game-instance',
  standalone: true,
  templateUrl: './choose-game-instance.component.html',
  imports: [
    MatFormField,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    MatLabel,
    MatHint,
    MatIcon,
    MatDatepickerToggle,
    MatDatepicker,
    MatButton,
    MatTooltip,
    AgGridAngular
  ],
  styleUrls: ['./choose-game-instance.component.scss']
})
export class ChooseGameInstanceComponent {

  @Output() public chosenGameInstanceEvent: EventEmitter<IGameInstance> = new EventEmitter<IGameInstance>();
  @Output() public resetGameInstanceEvent: EventEmitter<null> = new EventEmitter<null>();

  @Input() set gameIdSetter(gameIdP: string) {
    this.getGameInstancesForGame(gameIdP);
    // if the game is changed while this screen is already initiated and there is already a chosengame stored
    if (this.chosenGameId && this.chosenGameId !== gameIdP) {
      this.resetGameInstanceEvent.emit();
    }

    this.chosenGameId = gameIdP;
  }

  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;
  public drawDate: Date | null = null;
  public chosenGameId: string = "";
  public gameInstances: IGameInstance[] = [];
  public filteredGameInstances: IGameInstance[] = [];
  public columnDefs: ColDef[] = [
    {
      headerName: 'Draw Date',
      field: 'EndedOn',
      filter: 'agDateColumnFilter',
      valueFormatter: params => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y HH:mm');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'Started On',
      field: 'StartedOn',
      filter: 'agDateColumnFilter',
      valueFormatter: params => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'State',
      field: 'State',
      valueFormatter: params => {
        return this.gameInstanceStatusPipe.transform(params.value)
      }
    },
    {
      headerName: 'Starting Pot',
      field: 'StartingPot',
      valueFormatter: params => {
        return this.formatCurrency.transform(params.value)
      }
    },
    {
      headerName: 'Game Instance ID',
      field: 'Id'
    }
  ];


  public gameInstanceGridApi!: GridApi<IGameInstance>;

  constructor(private gameInstanceStatusPipe: GameInstanceStatusPipe,
              private formatCurrency: FormatCurrencyPipe,
              private datePipe: DatePipe,
              private dateService: DateService,
              private activeUserService: ActiveUserService,
              private errorHandlingService: ErrorHandlingService,
              private gameInstanceService: GameInstanceService) {
  }

  onRowSelected(rowDataP: any) {
    let gameInstanceFromChosenRow = this.gameInstances.find((instance) => instance.Id === rowDataP.data.Id);
    this.chosenGameInstanceEvent.emit(gameInstanceFromChosenRow)
  }

  onGameInstanceGridReady(params: GridReadyEvent<IGameInstance>) {
    this.gameInstanceGridApi = params.api;
    this.gameInstanceGridApi.sizeColumnsToFit({
      defaultMinWidth: 90,
    });
  }

  onDateInputChange(dateString: string) {
    if (dateString) {
      const parsedDate = new Date(dateString);

      if (!isNaN(parsedDate.getTime())) {
        this.filterResultsPerGameDrawDate(parsedDate);
      }

      return;
    }

    this.resetFilter();
  }

  public resetFilter() {
    this.drawDate = null;
    this.filteredGameInstances = this.gameInstances;
  }

  filterResultsPerGameDrawDate(parsedDateP: Date, overrideP: boolean = false) {

    if (parsedDateP && !overrideP) {
      this.filteredGameInstances = this.gameInstances.filter((reportP) => {
        return this.dateService.areDatesSameDay(reportP.EndedOn, parsedDateP)
      });

      return;
    }
    this.resetFilter();
  }

  public getGameInstancesForGame(gameIdP: string) {
    this.gameInstanceService.getGameInstancesByGameId(gameIdP, this.activeUserService.activeUser().Id).subscribe({
      next: (res) => {
        this.gameInstances = res;
        this.filteredGameInstances = this.gameInstances;
      }, error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    })
  }
}
